import Page from './HeaderNav';

export default Page;
